import { Swiper, SwiperSlide } from "swiper/react";
import {  Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from 'react-router-dom';
import  { destinations } from '../data/Destination';
import deafultImage from "../assets/tour-package.jpg"

const HoneymoonPackages = () => {
    const navigate = useNavigate();
    return (
        <>
            {Array.isArray(destinations) && destinations.length > 0 && (
                <>
                    {/* Heading */}
                    <div
                        className="mt-6 max-lg:mx-6 mx-6 text-start border-l-8 rounded-r-full bg-[#0B1C3D] border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12"
                        data-wow-delay="0.1s"
                        style={{ boxShadow: "0px 0px 20px 5px rgb(0 0 0 / 32%)" }}
                    >
                        <h1 className="playfair-display font-extrabold py-[6px] px-2 max-lg:text-xl text-2xl text-white">
                            Honeymoon Packages
                        </h1>
                    </div>

                    {/* Swiper */}
                    <div className="flex justify-center items-center relative w-full max-sm:px-0 xl:mx-4 mx-0">
                        <Swiper
                            modules={[Pagination, Autoplay]}
                            spaceBetween={10}
                            slidesPerView={1}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                768: { slidesPerView: 2 },
                                1024: { slidesPerView: 4 },
                            }}
                            loop={true}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            className="relative flex flex-col h-[60vh] max-xs:h-[45vh] cursor-pointer"
                            style={{ padding: "20px" }}
                        >
                            {destinations
                                .filter((d) => d?.categories?.includes("honeymoon"))
                                .map((pkg, index) => (
                                    <SwiperSlide key={pkg.id || index}>
                                        <div
                                            className="relative bg-white border border-[#D4AF37] p-1 rounded-xl flex flex-col items-center h-full"
                                            style={{ boxShadow: "0px 0px 20px 5px rgb(0 0 0 / 32%)" }}
                                            onClick={() => navigate(pkg?.link)}
                                        >
                                            {/* Image */}
                                            <div className="w-full h-[750px] overflow-hidden rounded-xl">
                                                <img
                                                    src={pkg?.image || deafultImage}
                                                    alt={pkg?.title || "destination"}
                                                    loading="lazy"
                                                    className="w-full h-full object-cover hover:scale-110 transition duration-500"
                                                />
                                            </div>

                                            {/* Content */}
                                            <div className="w-full h-[300px] py-1 px-2 flex flex-col justify-end">
                                                <h3 className="text-[#0B1C3D] mb-2 text-2xl font-semibold playfair-display">
                                                    {pkg?.name || "Destination"} Packages
                                                </h3>

                                                <p className="text-sm text-[#0B1C3D] poppins">
                                                    From{" "}
                                                    <span className="text-lg font-bold">
                                                        ₹{pkg?.price || "N/A"}/-
                                                    </span>{" "}
                                                    <span className="text-xs">Per Person</span>
                                                </p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                        </Swiper>
                    </div>
                </>
            )}
        </>
    )
}

export default HoneymoonPackages
